import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import {
  MemberSecurityQuestion,
  Response,
  SaveMemberSecurityAnswersCommand,
  SecurityQuestion,
  VerifyMemberSecurityAnswersCommand,
} from '../models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SecurityQuestionService {
  private securityQuestionApi: string = CONTROLLERS.SECURITY_QUESTIONS;
  private memberApi: string = CONTROLLERS.MEMBERS;

  constructor(private apiService: ApiService) {}

  getSecurityQuestions(): Observable<Response<SecurityQuestion[]>> {
    return this.apiService.get(
      `${this.securityQuestionApi}/${ENDPOINTS.SECURITY_QUESTIONS.LIST}`
    );
  }

  getMemberSecurityQuestions(): Observable<Response<MemberSecurityQuestion[]>> {
    return this.apiService.get(
      `${this.memberApi}/${ENDPOINTS.MEMBER.GET_SECURITY_QUESTIONS}`
    );
  }

  verifySecurityAnswers(
    body: VerifyMemberSecurityAnswersCommand
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.memberApi}/${ENDPOINTS.MEMBER.VERIFY_SECURITY_ANSWERS}`,
      body
    );
  }

  saveSecurityAnswers(
    body: SaveMemberSecurityAnswersCommand
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.memberApi}/${ENDPOINTS.MEMBER.SAVE_SECURITY_ANSWERS}`,
      body
    );
  }
}
